import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { PasswordDialogComponent } from './../password-dialog.component';

@Injectable()
export class PasswordDialogService {

  constructor(private modalService: NgbModal) { }

  public confirm(
    dialogSize: 'sm'|'md'|'lg' = 'sm',
    dialogCentered: true | false = true
    ): Promise<boolean> {
    const modalRef = this.modalService.open(PasswordDialogComponent, { size: dialogSize, centered: dialogCentered });

    return modalRef.result;
  }

}
